export default {
  // Config
  apiKey: "AIzaSyDHsE5rHOnqnd_qLZmZ0qDKyiliyv285q0",
  authDomain: "pioneerinterests-mytrace.firebaseapp.com",
  projectId: "pioneerinterests-mytrace",
  storageBucket: "pioneerinterests-mytrace.firebasestorage.app",
  messagingSenderId: "83068754213",
  appId: "1:83068754213:web:b660a84a69a1c15b7ea2cc"
};
